import { render, staticRenderFns } from "./BarraLateralItem.vue?vue&type=template&id=07211fee&scoped=true&"
import script from "./BarraLateralItem.vue?vue&type=script&lang=js&"
export * from "./BarraLateralItem.vue?vue&type=script&lang=js&"
import style0 from "./BarraLateralItem.vue?vue&type=style&index=0&id=07211fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07211fee",
  null
  
)

export default component.exports